"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../utils");
var paddingStyle = function (theme) {
    var styles = [];
    var breakpointsInfo = theme.global.breakpoints;
    var flexGridBreakpoints = theme.flexGrid.breakpoints;
    Object.keys(flexGridBreakpoints).forEach(function (breakpoint) {
        var outsideGutter = flexGridBreakpoints[breakpoint].outsideGutter;
        styles.push(utils_1.addBreakpoint(breakpointsInfo[breakpoint], "padding-left: " + outsideGutter + "px; padding-right: " + outsideGutter + "px;"));
    });
    return styles;
};
exports.StyledFlexGridContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n  ", "\n  ", "\n"])), function (props) { return "max-width: " + props.theme.flexGrid.maxWidth + "px;"; }, function (props) { return paddingStyle(props.theme); });
var templateObject_1;
//# sourceMappingURL=StyledFlexGridContainer.js.map